import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

export interface CartIconProps extends Omit<IconWrapperProps, 'color'> {
  color?: string;
}

const PrintIcon = ({ color = 'currentColor', ...rest }: CartIconProps) => (
  <IconWrapper width="40" height="40" viewBox="0 0 40 40" aria-hidden="true" {...rest}>
    <g id="print-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 16H27C28.66 16 30 17.34 30 19V25H26V29H14V25H10V19C10 17.34 11.34 16 13 16H14V11H26V16ZM24 13H16V16H24V13ZM16 27H24V23H16V27ZM26 21V23H28V19C28 18.45 27.55 18 27 18H13C12.45 18 12 18.45 12 19V23H14V21H26ZM26.7071 20.2071C26.5196 20.3946 26.2652 20.5 26 20.5C25.7348 20.5 25.4804 20.3946 25.2929 20.2071C25.1054 20.0196 25 19.7652 25 19.5C25 19.2348 25.1054 18.9804 25.2929 18.7929C25.4804 18.6054 25.7348 18.5 26 18.5C26.2652 18.5 26.5196 18.6054 26.7071 18.7929C26.8946 18.9804 27 19.2348 27 19.5C27 19.7652 26.8946 20.0196 26.7071 20.2071Z"
        fill={color}
      />
    </g>
  </IconWrapper>
);

export default PrintIcon;
